import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const navigate = useNavigate();
  // const { logout } = useAuth();

  const logout = async () => {
    await toast.success("logout successfully !")
    await setTimeout(()=>{
      localStorage.clear();
      navigate('/')
    },2000);


	}


  return (
    <div className="min-h-screen flex items-center justify-center">
      <div>
        <h1 className="text-4xl font-bold text-blue-500">Admin Dashboard</h1>
        <button
          onClick={()=>{logout()}}
          className="mt-4 bg-red-500 text-white px-4 py-2 rounded"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Dashboard;
